import React, { useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import PhoneIcon from 'src/assets/images/vectors/phone-icon-lp.svg'
import EmailIcon from 'src/assets/images/vectors/email-icon-lp.svg'
import ContactFormIcon from 'src/assets/images/vectors/contact-form-icon-lp.svg'

import ContactFormModal from 'src/components/ContactFormModal'

export const ContactSection = (props) => {
  const [contactFormModalOpen, setContactFormModalOpen] = useState(false);
  const { t } = useTranslation()

  return (
    <ContactSectionContainer>
        <div className='background-top'></div>
        <div className='background-bottom'></div>
        <div className='contact-overlay'>
            <div className='contact-overlay__section'>
                <img src={EmailIcon} alt='email-icon' />
                <div className='content'>
                    <a href='mailto:info@pandawlc.com'>info@pandawlc.com</a>
                </div>
            </div>
            <div className='contact-overlay__section'>
                <img src={PhoneIcon} alt='phone-icon' />
                <div className='content'>
                    <a href='tel:+48327202270'>+48 32 720 22 70</a>
                </div>
            </div>
            <div tabIndex={0} role='button' className='contact-overlay__section' onClick={() => setContactFormModalOpen(true)}>
                <img src={ContactFormIcon} alt='contact-form-icon' />
                <div className='content'>
                    <a>{t('landingPage.contactSection.messageUs')}</a>
                </div>
            </div>
        </div>
        <ContactFormModal open={contactFormModalOpen} onClose={() => setContactFormModalOpen(false)} />
    </ContactSectionContainer>
  )
}

export default ContactSection

const ContactSectionContainer = styled.div`
    height: 600px;
    position: relative;
    margin-top: 64px;

    ${props => props.theme.breakpointsMedia.desktop} {
        height: 300px;
        margin-top: 0;
    }

    .background-top, .background-bottom {
        height: 50%;
    }

    .background-top {
        background-color: ${props => props.theme.palette.background.paper}
    }

    .background-bottom {
        background-color: ${props => props.theme.palette.primary.dark};
    }

    .contact-overlay {
        top: 40px;
        left: calc(50vw - 165px);
        position: absolute;
        width: 330px;
        height: 402px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        border-radius: 30px;
        background-color: ${props => props.theme.palette.background.paper};
        box-shadow: 0px -10px 50px rgba(0, 0, 0, 0.24);
        padding: 64px 0;
        gap: 52px;

        ${props => props.theme.breakpointsMedia.desktop} {
            height: 100px;
            width: 936px;
            flex-direction: row;
            left: 50%; transform: translateX(-50%);
            padding: 64px 32px;
        }

        .contact-overlay__section {
            width: 310px;
            height: 100px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            cursor: pointer;
            justify-content: center;

            ${props => props.theme.breakpointsMedia.desktop} {
                justify-content: space-around;
            }

            .content {
                a {
                    font-size: 18px;
                    font-weight: 500;
                }
            }
        }
    }
`
